import './_product-grid-header.scss';

export default () => {};
